import { Box, Typography, Chip } from "@mui/material";
import { Assignment, AccessTime } from "@mui/icons-material";
import { truncateString } from "../../../../utils/truncate-string";
import { Assessment } from "../../../../models/assessments";
import { useNavigate } from "react-router-dom";

interface AssessmentPreviewCardProps {
  assessment: Assessment;
}

export function AssessmentPreviewCard({ assessment }: AssessmentPreviewCardProps) {
  const navigate = useNavigate();

  // const formatDate = (dateString: string) => {
  //   const date = new Date(dateString);
  //   return {
  //     date: date.toLocaleDateString('en-US', {
  //       month: 'short',
  //       day: 'numeric',
  //       year: 'numeric'
  //     }),
  //     time: date.toLocaleTimeString('en-US', {
  //       hour: 'numeric',
  //       minute: '2-digit'
  //     })
  //   };
  // };

  // const formattedDate = formatDate(assessment.last_updated);

  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: 80,
        backgroundColor: "white",
        border: 1,
        borderColor: assessment.submitted ? 'success.main' : 'grey.300',
        cursor: 'pointer',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: 2,
          borderColor: assessment.submitted ? 'success.dark' : 'grey.400',
        },
      }}
      onClick={() => navigate(`/classrooms/${assessment.classroom_id}/assessments/${assessment.id}`)}
    >
      {/* Header Section */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <Box sx={{ flex: 1 }}>
          <Typography 
            variant="subtitle2"
            sx={{
              fontWeight: 'bold',
              marginBottom: '4px',
              lineHeight: 1.2
            }}
          >
            {truncateString(assessment.title, 25)}
          </Typography>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
            <AccessTime sx={{ fontSize: 12, color: '#64748b' }} />
            <Typography 
              variant="caption" 
              sx={{ 
                color: '#64748b',
                fontSize: '0.7rem',
              }}
            >
              {assessment.multiple_submissions ? 'Multiple attempts' : 'Single attempt'}
              {assessment.duration > 0 && ` • ${assessment.duration} minutes`}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'flex-end', 
        alignItems: 'center',
        mt: 'auto'
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {(assessment.started_at && !assessment.submitted) && (
           <Chip
            label="STARTED"
            size="small"
            sx={{
              backgroundColor: '#fdecea',
              color: '#d32f2f',
              fontWeight: 600,
              fontSize: '0.6rem',
              height: 24,
              '& .MuiChip-label': {
                px: 1,
              },
            }}
          />

          )}

          <Chip
            icon={<Assignment sx={{ fontSize: 12 }} />}
            label={assessment.submitted ? "SUBMITTED" : "NOT SUBMITTED"}
            size="small"
            sx={{
              backgroundColor: assessment.submitted ? '#e8f5e8' : '#fef3c7',
              color: assessment.submitted ? '#2e7d32' : '#f59e0b',
              fontWeight: 600,
              fontSize: '0.6rem',
              height: 24,
              '& .MuiChip-label': {
                px: 1,
              },
              '& .MuiChip-icon': {
                marginLeft: 1,
                marginRight: -0.5,
              }
            }}
          />

        </Box>
      </Box>
    </Box>
  );
}